module.exports = __webpack_public_path__ + "img/262720.2e16d0f0.svg";